export default __webpack_public_path__ + "static/media/favicon.f0db8d69.ico";